import * as React from "react";
import * as ApolloClient from "@apollo/client";

import { FlexDataProviderProps } from "./types";





















export const FlexDataProvider = ({ children, dataClient }: FlexDataProviderProps): JSX.Element => {
    return (
        <>{dataClient && <ApolloClient.ApolloProvider client={dataClient}>{children}</ApolloClient.ApolloProvider>}</>
    );
};

FlexDataProvider.displayName = "DataProvider";
